export default "__VITE_ASSET__B8WyU3MI__";